import { render } from "./CheckboxText.vue?vue&type=template&id=c6de3cd0&scoped=true"
import script from "./CheckboxText.vue?vue&type=script&lang=js"
export * from "./CheckboxText.vue?vue&type=script&lang=js"

import "./CheckboxText.vue?vue&type=style&index=0&id=c6de3cd0&lang=less&scoped=true"

import exportComponent from "/builds/maizhensheng/app-commonapply-v6/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6de3cd0"]])

export default __exports__